<p class="t-header" *ngIf="filename">{{ filename }}</p>
<pre
  class="t-code"
  *ngFor="let content of processor$ | async"
><code [lineNumbers]="lineNumbers" [highlight]="content"></code></pre>
